export var dataHooks = {
  title: 'CustomModal-title',
  subtitle: 'CustomModal-subtitle',
  content: 'CustomModal-content',
  footerContent: 'CustomModal-footerContent',
  subheaderContent: 'CustomModal-subheaderContent'
};